import { createUseStyles } from 'react-jss';

type StylesProps = {
  backgroundImage: string;
};

const useStyles = createUseStyles(
  {
    root: ({ backgroundImage }: StylesProps) => ({
      backgroundImage: `url("${backgroundImage}")`,
      backgroundSize: 'contain',
      backgroundPosition: 'center top',
      backgroundRepeat: 'no-repeat',
    }),
  },
  {
    name: 'banner-container',
  },
);

export default useStyles;
